var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoAwesome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_539_43776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.46 8.00002L20.25 6.25002L22 5.46002C22.39 5.28002 22.39 4.73002 22 4.55002L20.25 3.76002L19.46 2.00002C19.28 1.61002 18.73 1.61002 18.55 2.00002L17.76 3.75002L16 4.54002C15.61 4.72002 15.61 5.27002 16 5.45002L17.75 6.24002L18.54 8.00002C18.72 8.39002 19.28 8.39002 19.46 8.00002ZM11.5 9.50002L9.91004 6.00002C9.56004 5.22002 8.44004 5.22002 8.09004 6.00002L6.50004 9.50002L3.00004 11.09C2.22004 11.45 2.22004 12.56 3.00004 12.91L6.50004 14.5L8.09004 18C8.45004 18.78 9.56004 18.78 9.91004 18L11.5 14.5L15 12.91C15.78 12.55 15.78 11.44 15 11.09L11.5 9.50002ZM18.54 16L17.75 17.75L16 18.54C15.61 18.72 15.61 19.27 16 19.45L17.75 20.24L18.54 22C18.72 22.39 19.27 22.39 19.45 22L20.24 20.25L22 19.46C22.39 19.28 22.39 18.73 22 18.55L20.25 17.76L19.46 16C19.28 15.61 18.72 15.61 18.54 16Z",
    fill: "url(#paint0_linear_539_43776)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_539_43776",
    x1: 2.41504,
    y1: 1.70752,
    x2: 22.2925,
    y2: 1.70752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DC0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#094056"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_539_43776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoAwesome);
export default __webpack_public_path__ + "static/media/AutoAwesome.587fd4bb978e0b15634518867bb6a0b4.svg";
export { ForwardRef as ReactComponent };